// Единый источник правды для путей роутинга (Задача 6 IT3).
// Хелперы строят URL по slug — чтобы не размазывать строки по компонентам.
export const ROUTES = {
  LOGIN: '/login',
  // Публичные страницы по ссылкам из писем: открываются без авторизации.
  RESET_PASSWORD: '/reset-password',
  VERIFY_EMAIL: '/verify-email',
  CONFIRM_EMAIL_CHANGE: '/confirm-email-change',
  CANCEL_EMAIL_CHANGE: '/cancel-email-change',
  // Публичная страница согласия на обработку персональных данных.
  POSITION: '/position',
  FOUNDATION: '/ui-foundation',
  INTEGRATIONS: '/integrations',
  INTEGRATION: (slug) => `/integrations/${slug}`,
  REFERENCE: (slug, type) => `/integrations/${slug}/references/${type}`,
  SCENARIO: (slug, scenarioId) => `/integrations/${slug}/scenarios/${scenarioId}`,
  EXPORT: (slug, exportId) => `/integrations/${slug}/exports/${exportId}`,
  CONNECT: (slug) => `/integrations/${slug}/connect`,
  LOGS: (slug) => `/integrations/${slug}/logs`
}
